import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { map } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { normalizeRouterPath } from 'src/app/services/platform.service';
import pkg from '../../../../../../package.json';

@Component({
  selector: 'app-use-desktop-app',
  templateUrl: './use-desktop-app.component.html',
  styleUrls: ['./use-desktop-app.component.css'],
  imports: [MatButtonModule, RouterLink],
})
export class UseDesktopAppComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  readonly desktopAppUrlDownload = `${environment.laravel_url}/storage/intranet/dist_electron/BisualIntranetApp-v${pkg.version}-mac.dmg`;

  readonly openInAppLink = toSignal(
    this.route.queryParamMap.pipe(
      map(params => {
        const rawReturnUrl = params.get('returnUrl') || '/employees/dashboard';
        const path = normalizeRouterPath(rawReturnUrl);
        const target =
          path === '/employees/use-desktop-app' || path.startsWith('/employees/use-desktop-app/') ? '/employees/dashboard' : path;
        return `bisualintranet:/${target}`;
      })
    ),
    { initialValue: 'bisualintranet://employees/dashboard' }
  );

  logout(): void {
    this.auth.logout();
    this.router.navigate(['/auth']);
  }
}
